import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SmartTabConfigInterface} from '../../interface';
import {Router} from '@angular/router';
import {AuthService, StateService} from '../../service';
import {MENU_CONFIG} from '../../const/menu-config';

@Component({
  selector: 'app-main-header-menu',
  templateUrl: './main-header-menu.component.html',
  styleUrls: ['./main-header-menu.component.scss']
})
export class MainHeaderMenu implements OnInit {

  tabsConfig: SmartTabConfigInterface[];
  @Input() transparentMode: boolean;
  @Output() tabChanged = new EventEmitter();
  isSidebarOpen: boolean;
  isLoggedIn: boolean;

  constructor(private router: Router, private stateService: StateService, private authService: AuthService) {

    this.tabsConfig = MENU_CONFIG;

    this.stateService.sideMenuState.subscribe((state) => {
      this.isSidebarOpen = state;
    });

    this.authService.token.subscribe(
      (token) => {
        this.isLoggedIn = !!token;
      }
    );

  }

  ngOnInit() {
  }

  tabClicked(tab) {
    this.router.navigateByUrl(tab.path);
  }


  toggleSideBar() {
    this.stateService.setSelectedSideMenuState(!this.isSidebarOpen);
  }

  openHome() {
    this.router.navigateByUrl('home');
  }

  logout() {
    this.authService.purgeAuth();
    this.router.navigateByUrl('home');
  }

}
